export function sortList(list) {
  if (!list) return list;

  const newList = [...list];
  newList.sort((a, b) => {
    const aName = a.name.toLowerCase();
    const bName = b.name.toLowerCase();
    if (aName < bName) return -1;
    if (aName > bName) return 1;
    return 0;
  });
  return newList;
}
